import { useEffect } from 'react';

interface JsonLdProps {
  data: Record<string, any> | Record<string, any>[];
}

export function JsonLd({ data }: JsonLdProps) {
  useEffect(() => {
    // Locate or create our dedicated script tag
    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.innerHTML = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      // Clean up upon unmounting to avoid script tag bloating
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, [data]);

  return null;
}
